import { render, staticRenderFns } from "./VideoPostMedia.vue?vue&type=template&id=08dbd2f1&scoped=true&"
import script from "./VideoPostMedia.vue?vue&type=script&lang=js&"
export * from "./VideoPostMedia.vue?vue&type=script&lang=js&"
import style0 from "./VideoPostMedia.vue?vue&type=style&index=0&id=08dbd2f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbd2f1",
  null
  
)

export default component.exports